export const getZoomValue = (value: string): number => Number(value.replace('%', ''));

export const toPercent = (value: number): string => `${value}%`;

export const ZOOM_VALUE_REG_EXP = /^\d{0,3}%?$/;
